import { FormValues } from '@zoopla/listing-search/filters/modal';
import { useContext } from 'react';
import {
    SelectTravelTime,
    SelectGroupTravelTime,
    SelectDuration,
    SelectTransportType
} from './SelectMaxTravelTimeAndTransportMode';
import { SelectRadius } from './SelectRadius';
import { coerceQueryParameter } from '../utils/coerceQueryParameter';
import { SearchBarContext } from './SearchBar';

export const SelectDistance = () => {
    const { isTravelTimeSearch, showRadius, formValue, updateFormValue } =
        useContext(SearchBarContext);

    if (!isTravelTimeSearch) {
        if (showRadius) {
            return (
                <SelectRadius
                    value={coerceQueryParameter(formValue.radius)}
                    onChange={(radius) => {
                        updateFormValue?.((oldFormValue: FormValues) => ({
                            ...oldFormValue,
                            radius: radius
                        }));
                    }}
                />
            );
        }

        return null;
    }

    return (
        <SelectTravelTime>
            <SelectGroupTravelTime>
                <SelectDuration />
                <SelectTransportType />
            </SelectGroupTravelTime>
        </SelectTravelTime>
    );
};
